import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";
import type { MeetingDoc } from "../../services/meetingDocsEndpoint";
import MeetingDocTabs, { type DocTab } from "./MeetingDocTabs";

export type { DocTab };

type DocDetailDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title?: string;
  prepDoc?: MeetingDoc | null;
  followupDoc?: MeetingDoc | null;
  customDocs?: MeetingDoc[];
  initialTab?: DocTab;
};

const DocDetailDialog = ({
  open,
  onOpenChange,
  title,
  prepDoc,
  followupDoc,
  customDocs = [],
  initialTab,
}: DocDetailDialogProps) => {
  const displayTitle = title || "Meeting Docs";

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl p-0">
        <DialogHeader className="border-b border-border px-6 py-4">
          <div className="flex items-center justify-between gap-3">
            <div className="min-w-0">
              <DialogTitle className="truncate text-base">{displayTitle}</DialogTitle>
              <DialogDescription className="mt-1 text-xs text-muted-foreground">
                AI-generated docs for this meeting
              </DialogDescription>
            </div>
          </div>
        </DialogHeader>

        <div className="px-6 pt-3">
          <MeetingDocTabs
            prepDoc={prepDoc}
            followupDoc={followupDoc}
            customDocs={customDocs}
            initialTab={initialTab}
            resetKey={open ? "open" : "closed"}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default DocDetailDialog;
